export const GillianLynneTheatre = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#c0c9ce'
  },
  themeVenueLogo: 'gillian_lynne_sw_icon.png',
  themeVenueName: 'Gillian Lynne Theatre',
  themeVenueAddress: '166 Drury Lane, London WC2B 5PF'
}
